import { Icon } from "@sellar-io/components";
import { twMerge } from "tailwind-merge";

type AwardTier = "gold" | "silver" | "bronze";

const tierStyles: Record<
  AwardTier,
  {
    bgColor: string;
    outlineColor: string;
    iconColor: string;
    labelColor: string;
    textColor: string;
    label: string;
  }
> = {
  gold: {
    bgColor: "bg-yellow-50",
    outlineColor: "outline-yellow-300",
    iconColor: "text-yellow-600",
    labelColor: "text-yellow-600",
    textColor: "text-yellow-800",
    label: "1st",
  },
  silver: {
    bgColor: "bg-gray-50",
    outlineColor: "outline-gray-300",
    iconColor: "text-gray-500",
    labelColor: "text-gray-500",
    textColor: "text-gray-700",
    label: "2nd",
  },
  bronze: {
    bgColor: "bg-orange-50",
    outlineColor: "outline-orange-300",
    iconColor: "text-orange-700",
    labelColor: "text-orange-700",
    textColor: "text-orange-900",
    label: "3rd",
  },
};

export const OverallChampionBadge = ({
  tier,
  type,
  className,
}: {
  tier: AwardTier;
  type: string;
  className?: string;
}) => {
  const { bgColor, outlineColor, iconColor, labelColor, textColor, label } =
    tierStyles[tier];

  return (
    <div
      className={twMerge(
        "inline-flex w-full items-center justify-center gap-1 rounded-lg px-3 py-1.5 outline outline-1 outline-offset-[-1px]",
        bgColor,
        outlineColor,
        className,
      )}
    >
      <div className="inline-flex items-center">
        <Icon icon={"LICENSE"} className={iconColor} />
        <div
          className={twMerge(
            "justify-end font-['Inter'] text-xs leading-4 font-semibold",
            labelColor,
          )}
        >
          {label}
        </div>
      </div>
      <div
        className={twMerge(
          "justify-end font-['Inter'] text-xs leading-4 font-medium",
          textColor,
        )}
      >
        • {type}
      </div>
    </div>
  );
};
